// Widget Studio — definition catalog detail (CHG-2471 / ITER-905213, S5).
//
// Read-only catalog entry; no mutating actions. Config in
// @generated/screens/widget-definition-detail, regenerated from
// widget-definition.entity-hint.yaml. Route /channels/widgets/catalog/:widgetDefinitionId.

import { DetailPage } from "../components/composition";
import { widgetDefinitionDetailConfig } from "../generated/screens/widget-definition-detail";

export function WidgetDefinitionDetail() {
  return <DetailPage config={widgetDefinitionDetailConfig} />;
}
